export const optionSelectedMap: Record<string, string> = {
  'My integrations': 'my integrations',
  'Build integrations': 'information',
  Docs: 'documentation',
  Tools: 'partners',
  'Partner Program': 'partners',
  Resources: 'help',
};
